import React from 'react';
import { useTranslation } from '@hooks/useTranslation';
import CustomDateTimePicker from './CustomDateTimePicker';
import './DateRangePicker.scss';

const DateRangePicker = ({
    fromDate,
    untilDate,
    onFromDateChange,
    onUntilDateChange,
    dateFormat,
    calendar,
    locale,
    disabled = false,
    currentLanguage,
    fromLabel = 'reservation.reserved_from',
    untilLabel = 'reservation.reserved_until',
    fromPlaceholder = 'reservation.select_from_date',
    untilPlaceholder = 'reservation.select_until_date'
}) => {
    const { t } = useTranslation();

    return (
        <div className="date-range-picker">
            <div className="form-group">
                <label htmlFor="reserved_from">
                    {t(fromLabel)} *
                </label>
                <CustomDateTimePicker
                    value={fromDate}
                    onChange={onFromDateChange}
                    format={dateFormat}
                    calendar={calendar}
                    locale={locale}
                    disabled={disabled}
                    placeholder={t(fromPlaceholder, 'Select start date and time')}
                    minDate={new Date()}
                    currentLanguage={currentLanguage}
                />
            </div>

            <div className="form-group">
                <label htmlFor="reserved_until">
                    {t(untilLabel)} *
                </label>
                <CustomDateTimePicker
                    value={untilDate}
                    onChange={onUntilDateChange}
                    format={dateFormat}
                    calendar={calendar}
                    locale={locale}
                    disabled={disabled}
                    placeholder={t(untilPlaceholder, 'Select end date and time')}
                    minDate={fromDate ? fromDate.toDate() : new Date()}
                    currentLanguage={currentLanguage}
                />
            </div>
        </div>
    );
};

export default DateRangePicker;
